import MksAlert from "./Alert.vue";
import MksAvatar from "./Avatar.vue";
import MksButton from "./Button.vue";
import MksFieldError from "./FieldError.vue";
import MksDateNumber from "./DateNumber.vue";
import MksFieldLabel from "./FieldLabel.vue";
import MksHeading from "./Heading.vue";
import MksIcon from "./Icon.vue";
import MksLink from "./Link.vue";
import MksLoading from "./Loading.vue";
import MksLogotype from "./Logotype.vue";
import MksNumber from "./Number.vue";
import MksSeparator from "./Separator.vue";
import MksTag from "./Tag.vue";
import MksText from "./Text.vue";
import MksToggle from "./Toggle.vue";
import MksVisuallyHidden from "./VisuallyHidden.vue";
import MksTab from "./Tab.vue";

const atoms = {
  MksAlert,
  MksAvatar,
  MksButton,
  MksFieldError,
  MksDateNumber,
  MksFieldLabel,
  MksHeading,
  MksIcon,
  MksLink,
  MksLoading,
  MksLogotype,
  MksNumber,
  MksSeparator,
  MksTag,
  MksText,
  MksToggle,
  MksVisuallyHidden,
  MksTab
};

export default {
  install(vueApp) {
    Object.entries(atoms).forEach(([name, component]) => {
      vueApp.component(name, component);
    });
  }
}
